var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F5F8FD",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3062D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.7 29.6h-6a2.4 2.4 0 0 1-2.4-2.4V12.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v4.8m.6 9 1.2 1.2m-.6-3.6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon4);
export default __webpack_public_path__ + "static/media/search-icon-4.4fae701b414d39408730228291171f9e.svg";
export { ForwardRef as ReactComponent };